import { ChangeDetectionStrategy, Component, TemplateRef, input, viewChild } from '@angular/core';

@Component({
  selector: 'dss-libs-ui-tab',
  imports: [],
  templateUrl: './tab.component.html',
  styleUrl: './tab.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabComponent {
  readonly template = viewChild.required<TemplateRef<any>>('template');
  readonly title = input('');
}
